module.exports = __webpack_public_path__ + "img/bj.4660c920.svg";